<template>
  <!-- renewal 스타일이 적용되는 범위. embed CSS 의 모든 셀렉터가 `.renewal-root` 를
       요구하므로, 이 래퍼 밖(헤더·푸터)으로는 renewal CSS 가 새지 않는다.
       `.renewal-page` 는 body 에서 갈라 온 배경·높이를 받는 콘텐츠 루트 전용 클래스다.

       `:key` 는 프리렌더 언어와 실제 언어가 다를 때만 값이 바뀌어, 마운트 직후
       콘텐츠를 한 번 다시 그린다. renewal 본문은 전부 v-html 이고 Vue 는 hydration 에서
       innerHTML 을 교정하지 않기 때문이다(application/components/Home/CLAUDE.md 참고). -->
  <div :key="hydrationKey" class="renewal-root renewal-page" @click="onClickRenewalLink">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { useRenewalHydrationKey } from '~~/codepresso-renewal/composables/useRenewalText';
import { useRenewalLinkInterception } from '~/composables/useRenewalLinkInterception';

// 언어 주입은 여기가 아니라 app.vue 가 한다 — 헤더(GNB)가 콘텐츠보다 먼저 렌더되므로
// 여기서 걸면 SSR 출력의 GNB 만 기본 언어로 남는다.
const onClickRenewalLink = useRenewalLinkInterception();
const hydrationKey = useRenewalHydrationKey();
</script>

<style lang="scss">
@import "~/assets/scss/abstracts/variables.scss";
@import "~/assets/scss/abstracts/mixin.scss";

// renewal 페이지는 **헤더가 콘텐츠 위에 겹쳐 뜨는 것**을 전제로 짜여 있다.
// renewal 단독 사이트의 헤더는 `position: fixed` 에 배경이 투명이고, 히어로가 그만큼을
// 자기 padding 으로 비워 둔다 — `.hero-wrap { padding: 132px 24px 48px }` (헤더 80px + 52px).
//
// 우리 헤더는 흐름에서 자리를 차지하므로 그대로 두면 두 가지가 어긋난다.
//   1. 히어로가 헤더 높이만큼 더 내려가 상단 여백이 설계보다 81px 넓어진다.
//   2. 히어로의 배경 — 상단 브랜드 광원(`.sub-hero::after`), 텍스처(`::before`),
//      다크 페이지의 그라데이션 — 이 헤더 아래에서 잘린다. 헤더 자체는 투명인데도
//      그 자리에 페이지 배경만 평평하게 남아 불투명한 띠처럼 보인다.
//
// renewal 의 CSS·DOM 은 그대로 두고(요구 5), 콘텐츠를 헤더 높이만큼 끌어올려 헤더 뒤로
// 넣는다. 헤더는 z-index 1000 이라 위에 남고, 히어로가 이미 비워 둔 여백 덕에 글자가
// 가려지지 않는다.
// `.renewal-root` 까지 함께 쓰는 이유: embed reset 의 `.renewal-root { margin: 0 }` 과
// 우선순위가 같으면 로드 순서에 따라 지는데, 그 순서는 번들러가 정한다.
.renewal-root.renewal-page {
  // `.headerMain .container` 80px + 헤더 아래 테두리 1px (_header.scss).
  margin-top: -81px;

  // 모바일에서는 겹치지 않는다 — 그 폭에서 우리 헤더는 흰 면으로 고정이라
  // (`_header.scss` 의 screen-1080 분기) 뒤로 넣으면 콘텐츠가 가려진다.
  @include mq(screen-1080) {
    margin-top: 0;
  }
}
</style>
